import { createApp } from 'vue';
import Newsletter from './components/newsletter/Newsletter.vue';
import LoginHeader from './components/user/LoginHeader.vue';
import User from './components/user/User.vue';
import Topic from './components/discuss/topic/Topic.vue';
import MapProject from './components/discuss/MapProject.vue';
import Project from './components/discuss/Project.vue';
import ForumProject from './components/forum/ForumProject.vue';
import WdwQuarterMap from './components/discuss/WdwQuarterMap.vue';
import NewsProject from './components/news/NewsProject.vue';
import NewsProjectPreview from './components/news/NewsProjectPreview.vue';
import Calendar from './components/calendar/Calendar.vue';
import Timeline from './components/timeline/Timeline.vue';
import AttributeEditor from './components/attribute/editor/AttributeEditor.vue';
import DocumentDiscussion from './components/document_discussion/DocumentDiscussion.vue';
import BmsBoard from './components/bms/bms_board/BmsBoard.vue';
import BmsWizardWrapper from './components/bms/wizard/BmsWizardWrapper.vue';
import Askus from './components/askus/Askus.vue';
import './global.ts';
import { createRouter, createWebHashHistory } from 'vue-router';
import { registerRequirementsOn } from './global_initApp';

const routes: any[] = []; // empty routes, we only use queryParams from Router
let router: any;

const domSelector = '.wdw-widgets';
const mountEl: NodeListOf<HTMLElement> = document.querySelectorAll(domSelector);

mountEl.forEach(element => {
  if (element !== null) {
    if (element.classList.contains('wdw-no-router')) {
      //  #########
      //  ### MOUNT COMPONENTS WITHOUT ROUTING IF SPECIFIC CLASS (special internal use case)
      //  ### only mount components that do not required routing here
      //  #########
      const app = createApp({
        components: {
          Timeline,
          AttributeEditor,
        },
      });

      registerRequirementsOn(app);

      app.mount(element);
    } else {
      //  #########
      //  ### MOUNT ALL COMPONENTS WITH ROUTING
      //  #########

      const app = createApp({
        components: {
          LoginHeader,
          User,
          Newsletter,
          Topic,
          MapProject,
          ForumProject,
          WdwQuarterMap,
          Project,
          NewsProject,
          NewsProjectPreview,
          Calendar,
          Timeline,
          AttributeEditor,
          DocumentDiscussion,
          BmsBoard,
          BmsWizardWrapper,
          Askus,
        },
      });

      registerRequirementsOn(app);

      // init router here to only create when required (otherwise "-no-router"-part above will not work)
      if (!router) {
        router = createRouter({ history: createWebHashHistory(), routes: routes });
      }
      app.use(router);

      app.mount(element);
    }
  } else {
    console.error('element not found: ' + domSelector);
  }
});

/*
    Instantiate components in client HTML using a wrapper element.
    You may initiate one component or multiple components within the wrapper element.
    You may include multiple wrapper elements on the same page.

      <div class="wdw-widgets">
          <login :{prop-name}="{prop-value}"></login>
          <newsletter :{prop-name}="{prop-value}"></newsletter>
      </div>
      
      <div class="wdw-widgets">
          <topic :{prop-name}="{prop-value}"></topic>
      </div>

    For components without routing capabilities such as Timeline and AttributeEditor, add wdw-no-router class

      <div class="wdw-widgets wdw-no-router">
          <timeline :{prop-name}="{prop-value}"></timeline>
      </div>
*/
